
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {standardApi, standardPublicApi} from "@/api/standard";
    import baseUrl, {imageUrl} from "@/constants";
    import {IPage} from "@/js/page";
    const {regionData} =require("@/js/region/region");
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";

    @Component({
        name: "MapsList",
        components: {TableShowRangeHead, TableShowRangeBody}
    })
    export default class MapLise extends Vue {
        title = "社会公用计量标准";
        listData = [] as any;
        private closePage: any;
        code = "";
        codeName = "";
        showForm = false;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        propParams = {
            standardName: '',//名称
            status: "",// 状态 0:待提交 1:未审核  2:已生效  3:未通过
            useStatus: '',//使用状态：1.在用 2.暂停 3.封存 4.撤销
            organizationName: '', //建标单位
            certificateNo: '',//考核证书号
            issuingAuthority: '',//发证机关
            issuedDate: '',//发证日期
            termValidity: '',//有效期
            issuedDateEnd: '',//发证日期结束
            termValidityEnd: '',//有效期结束
            mode: "",
        } as any;
        detailDialog = false;
        form = {
            /**
             * '社会公用计量标准证书号'
             */
            certificateNo: "",
            /** 单位ID */
            ownerId: "",
            /** 单位NameID */
            companyNameId: "",
            /**
             * 建标单位
             */
            companyName: "",
            /**
             * 计量标准名称
             */
            name: "",
            /**
             * 计量标准的ID
             */
            measuringId: '',
            /**
             * 测量范围
             */
            // surveyRange: "",
            /**
             * 不确定度或准确度等级或最大允许误差
             */
            maxError: "",
            /**
             * 不确定度或准确度等级或最大允许误差
             */
            maxErrors: [],
            /**
             * 发证机关别名
             */
            issuingAuthorityNameId: "",
            /**
             * 发证机关
             */
            issuingAuthority: '',
            /**
             * 发证日期
             */
            issuedDate: "",
            /**
             * 有效日期
             */
            termValidity: '',
            /**
             * 使用状态
             */
            useStatus: '',
            /**
             * 传递地区或范围
             */
            transmitAddress: "",
            transmitAddressArr: [],
            /**
             * 计量标准考核证书号
             */
            assessmentCertificateNo: "",
            /**
             * 计量授权证书号
             */
            authorizationCertificateNo: "",
            /**
             * 计量标准考核证书影硬件
             */
            enclosure: "",
            /**
             * 检定或效验项目列表
             */
            measuringItems:[],
            /**
             *  测量范围
             */
            measuringScopes: [],
            /**
             * 参数列表 含测量范围 准确度等级
             */
            paramList: [],
            /**
             * 0:待提交
             * 1:未审核
             * 2:已生效
             * 3:未通过
             * */
            status: 0,
        }
        standardList = [] as any;
        fileList = [] as any;
        regionDataAll = JSON.parse(JSON.stringify(regionData))
        regionData = regionData;



        mounted() {
            this.code = this.$route.query.code as any;
            this.codeName = this.$route.query.codeName as any;
            this.list();
        }

        refresh() {
            this.listParam.current = 1;
            this.list();
        }

        reset() {
            for (const f in this.propParams) {
                this.propParams[f] = "";
            }
            this.refresh();
        }

        list() {
            const params = {
                ...this.listParam,
                ...this.propParams,
                organizationRegion: this.code,
            };
            params.status = 2;
            params.mode = "-";
            params.modeValue = "-";
            standardPublicApi.pageV2(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                }
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        down(row: any) {
            try {
                var obj = JSON.parse(row);
                if (typeof obj == 'object' && obj) {
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=社会公用计量标准证书影印件", '_blank');
                return false;
            }
        }
        detail(data: any) {
            this.getStandard(data.id, data.standardName);
            this.detailDialog = true;
        }
        getStandard(id:any, name: string){
            standardPublicApi.getStandard({id:id}).then((r: any) => {
                if (r.data.result === 0) {
                    this.form = r.data.data;
                    this.form.name = name;
                    this.form.useStatus = r.data.data.useStatus.value;
                    try{
                        this.form.transmitAddressArr = JSON.parse(this.form.transmitAddress);
                        this.changeAddress(this.form.transmitAddressArr);
                    }catch (e) {
                        this.form.transmitAddressArr = [];
                    }
                    this.getTable();
                    this.pageStandard("");
                    if(this.form.enclosure){
                        this.fileList = [];
                        try {
                            var obj=JSON.parse(this.form.enclosure);
                            if(typeof obj == 'object' && obj ){
                                for(let i = 0; i < obj.length; i++){
                                    this.fileList.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                                }
                            }
                        } catch(e) {
                            const arr = this.form.enclosure.split(",");
                            for(let i = 0; i < arr.length; i++){
                                this.fileList.push({name:"证书文件",url: imageUrl+arr[i]})
                            }
                        }
                    }
                }
            })
        }
        changeAddress(values: any){
            this.regionData = JSON.parse(JSON.stringify(this.regionDataAll));
            const addressCodes = [] as any;
            values.forEach((list: any) => {
                const code = list[list.length -1];
                addressCodes.push(code);
            });
            addressCodes.forEach((code: string) => {
                const regionData = this.getRegionData(code, this.regionData);
                this.changeChild(regionData);
            });
        }
        getRegionData(code: string, projectList: any){
            let result = null as any;
            for(let i =0; i<projectList.length; i++){
                const project = projectList[i];
                if(project.value === code){
                    result = project;
                    break;
                }else{
                    if(project.children != null){
                        const r = this.getRegionData(code, project.children);
                        if(r != null){
                            result = r;
                            break;
                        }
                    }
                }
            }
            return result;
        }
        changeChild(regionData: any){
            if(regionData != null && regionData.children != null) {
                regionData.children.forEach((child: any) => {
                    child.disabled = true;
                    if (child.children) {
                        this.changeChild(child);
                    }
                });
            }
        }
        getTable() {
            standardApi.getMeasuringStandard({id: this.form.measuringId}).then((r: any) => {
                if (r.data.result === 0) {
                    const items = r.data.data.measuringItems;
                    const changeFrom = this.form;
                    let paramList = r.data.data.paramList;
                    changeFrom.paramList = paramList;
                    const measuringItems = [] as any;
                    items.forEach((item: any) => {
                        const paramList = JSON.parse(item.surveyRangesJson);
                        measuringItems.push({
                            id: item.id,
                            measuringId: item.measuringId,
                            projectId: item.projectId,
                            firstChild: true,
                            name: item.name,
                            paramList: paramList,
                        });
                    });
                    this.form.measuringItems = measuringItems;
                }
            })
        }
        pageStandard(name : string){
            const params = {
                ownerId: this.form.ownerId,
                ...this.listParam,
                // status: 2,
                name: name
            }
            standardApi.mapPage(params).then((r: any) => {
                if (r.data.result === 0) {
                    const measuringId = this.form.measuringId;
                    const standard = r.data.data.records.find((rd: any) => rd.id === measuringId);
                    const standardList = r.data.data.records.filter((rd: any) => rd.status.value === 2);
                    if(standard && standard.status.value != 2){
                        standardList.unshift(standard);
                    }
                    this.standardList = standardList
                }
            })
        }
        objectSpanMethod({rowIndex, columnIndex, row}: any) {
            if (columnIndex === 0) {
                if (row.firstChild) {
                    const rowCount = this.form.measuringItems.filter((item: any) => item.number == row.number).length;
                    return {
                        rowspan: rowCount,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        }
    }
